<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <!--    <SubscriptionTypeModal :open-modal="openCreateModal"/>-->
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <SubscriptionTypeModal :open-modal="openCreateModal" @closemodal="disableModal"/>
      <va-card :title="$t('subscriptions.subscriptionsAndCharges')">
        <template slot="actions">
          <va-button icon="fa fa-plus" @click="createModal"  />
          <!--          to="create-app-subscription"-->
        </template>
        <div class="va-card__body" v-if="appSubscriptions.length < 1">
          <va-notification v-if="appSubscriptions.length < 1" color="info">
            <va-badge color="info">
              {{ $t('badges.info') }}
            </va-badge>
            {{ $t('subscriptions.noSubscriptionsFound') }}
          </va-notification>
        </div>
      </va-card>
    </div>

    <div v-if="!this.$store.getters.isLoading && appSubscriptions.length > 0" class="flex xs12">
      <div class="cards-container row d-flex wrap align--start subscription-cards">
        <div class="flex xs12 sm6 lg4 xl3" v-for="(element, index) in appSubscriptions" :key="element.appSubscriptionId">
          <va-card>
            <div class="va-card__header">
              <div class="va-card__header-title" style="color: rgb(108, 127, 238);">{{ element.name }} <va-badge>{{subscriptionType(element)}}</va-badge>
                <span v-if="element.isGlobal" :title="$t('subscriptions.globalIcon')"><i class="va-icon fa fa-globe"></i></span>
                <span v-if="!element.isWithoutPrice && element.isUserShow" :title="$t('subscriptions.showClientIcon')"><i class="va-icon fa fa-user"></i></span>
                <span v-if="element.isWithoutPrice && element.isRequestTip" :title="$t('subscriptions.requestTipIcon')"><i class="va-icon fa fa-credit-card"></i></span>
              </div>
              <div class="va-card__header-actions">
                <KebabMenu>
                  <div slot="buttons">
                    <va-button-group>
                      <va-button flat small color="gray" @click="toAppSubscriptionUpdate(element)" icon-right="fa fa-edit"> {{ $t('subscriptions.edit') }}</va-button>
                      <va-button flat small color="gray" @click="showPromptModal(element.appSubscriptionId, index)" icon-right="fa fa-trash"> {{ $t('subscriptions.remove') }}</va-button>
                    </va-button-group>
                  </div>
                </KebabMenu>
              </div>
            </div>
            <p v-if="!element.isGlobal">Locations: <span>{{element.events.length}}</span></p>
            <p v-if="!element.isWithoutPrice && !element.isFixPrice">Prices: <span>{{element.appSubscriptionPrices.length}}</span></p>
            <p v-if="!element.isWithoutPrice && element.isFixPrice">Price: <span>{{element.appSubscriptionPrices[0].price}}</span></p>
          </va-card>
        </div>
      </div>
    </div>
    <va-modal
      v-model="showRemoveModal"
      size="small"
      :title="$t('subscriptions.deleteModalTitle')"
      :message="$t('subscriptions.deleteModalMessage')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <div class="d-flex justify--center mt-3">
        <va-button color="gray" @click="showRemoveModal=false" class="my-0 ">{{ $t('subscriptions.modalNo') }}</va-button>
        <va-button type="submit" @click="removeAppSubscription(appSubscriptionIdInPrompt, indexInPrompt)" class="my-0">{{ $t('subscriptions.modalYes') }}</va-button>
      </div>
    </va-modal>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import SubscriptionTypeModal from '../appSubscriptions/SubscriptionTypeModal'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
import KebabMenu from '@/components/menus/KebabMenu.vue'
export default {
  // eslint-disable-next-line no-undef,vue/no-unused-components
  components: { SwappingSquaresSpinner, SubscriptionTypeModal, KebabMenu },
  mixins: [errorHandlerMixin],
  name: 'AppSubscription',
  data () {
    return {
      openCreateModal: false,
      messageAction: {
        message: '',
        includeUrl: false,
      },
      modalLoader: false,
      appSubscriptions: [],
      dragging: false,
      showRemoveModal: false,
      indexInPrompt: null,
      appSubscriptionIdInPrompt: null,
    }
  },
  methods: {
    async createModal () {
      this.openCreateModal = true
    },
    async disableModal (state) {
      this.openCreateModal = state
    },
    async toAppSubscriptionUpdate (appSubscription) {
      const type = appSubscription.isWithoutPrice ? 'free' : appSubscription.isFixPrice ? 'fix' : 'charge'
      await this.$router.push({
        name: 'update-app-subscription',
        params: {
          type: type,
          appSubscriptionId: appSubscription.appSubscriptionId,
        },
      })
    },
    showPromptModal (appSubscriptionId, index) {
      this.appSubscriptionIdInPrompt = appSubscriptionId
      this.indexInPrompt = index
      this.showRemoveModal = true
    },
    subscriptionType (appSubscription) {
      return appSubscription.isWithoutPrice ? this.$t('subscriptions.free') : appSubscription.isFixPrice ? this.$t('subscriptions.fixPrice') : this.$t('subscriptions.charge')
    },
    removeAppSubscription (appSubscriptionId, index) {
      this.$store.dispatch('deleteAppSubscription', appSubscriptionId).then(() => {
        this.appSubscriptions.splice(index, 1)
        this.showRemoveModal = false
      }).catch(error => {
        this.errorHandler(error.response)
        this.showRemoveModal = false
      })
    },
    async initAppSubscriptions () {
      this.appSubscriptions.splice(0, this.appSubscriptions.length, ...this.$store.getters.appSubscriptions)
      this.$store.commit('setLoading', false)
    },
  },
  computed: {
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getAppSubscriptions')
      .then(() => this.initAppSubscriptions())
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style lang="scss">
  .subscription-cards {
    .va-card {
      min-height: 130px;

      &__header {
        display: flex;
        align-items: center;

        &-title {
          font-size: 1rem;
          display: flex;
          align-items: center;

          &:hover {
            cursor: pointer;
          }

          .va-badge {
            margin-left: 5px;
          }

          .va-icon {
            margin-right: 5px;
          }
        }

        &-actions {
          display: flex;
        }
      }

      &__body {
        overflow: visible;
        min-height: 130px;

        .va-button--small.va-button--with-right-icon {
          padding-right: 0.75rem;
        }

        p {
          font-size: 14px;
        }

        .flex-checkbox {
          display: flex;
          align-items: center;
        }
      }
    }
  }
</style>
